import { useEffect, useState } from "react";
import { CaseSummary } from "./CaseSummary";
import { CaseImages } from "./CaseImages";
import { CaseUpdates } from "./CaseUpdates";
import { Card } from "./ui/Card";
import { CondoCase } from "types/CondoCase";
import { useAuth } from "context/AuthContext";

interface CasePanelProps {
  case: CondoCase;
  onUpdate?: (updatedCase: CondoCase) => void;
}

type CaseDetailTab = "updates" | "photos";

export function CasePanel({ case: caseItem, onUpdate }: CasePanelProps) {
  const [activeTab, setActiveTab] = useState<CaseDetailTab>("updates");
  const { lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";
  const tr = (es: string, en: string) => (locale === "es" ? es : en);

  useEffect(() => {
    setActiveTab("updates");
  }, [caseItem.id]);

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden lg:gap-4">
      <div className="shrink-0">
        <CaseSummary case={caseItem} onUpdate={onUpdate} />
      </div>
      <Card className="flex min-h-0 flex-1 flex-col overflow-hidden p-0">
        <div
          className="flex shrink-0 border-b border-gray-200"
          role="tablist"
          aria-label={tr("Detalle del incidente", "Incident details")}
        >
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "updates"}
            onClick={() => setActiveTab("updates")}
            className={`px-4 py-3 text-sm font-medium transition ${
              activeTab === "updates"
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tr("Actualizaciones", "Updates")}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "photos"}
            onClick={() => setActiveTab("photos")}
            className={`px-4 py-3 text-sm font-medium transition ${
              activeTab === "photos"
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tr("Fotos", "Photos")}
          </button>
        </div>
        <div
          className="min-h-0 flex-1 overflow-hidden p-4"
          role="tabpanel"
        >
          {activeTab === "updates" ? (
            <CaseUpdates caseId={caseItem.id} embedded />
          ) : (
            <CaseImages caseId={caseItem.id} embedded />
          )}
        </div>
      </Card>
    </div>
  );
}
